// POST /tickets recusa quando o contato já tem ticket aberto/pendente na conexão:
// 409 com o ticket serializado em `error`, ou 403 com `{ error, message, ticket }`
// (ticket de outro atendente ou ainda sem atendente). Devolve o ticket ou null.
export const existingTicketFromError = (err) => {
  const data = err?.response?.data;
  if (!data) return null;
  if (data.ticket && data.ticket.uuid) return data.ticket;
  if (typeof data.error === "string") {
    try {
      const parsed = JSON.parse(data.error);
      if (parsed && parsed.uuid) return parsed;
    } catch (e) {
      return null;
    }
  }
  return null;
};

// Ticket sem atendente (ex.: aberto por mensagem enviada pelo celular) ou do próprio
// usuário: abre direto. Só o de outro atendente mostra o aviso.
export const canOpenExistingTicket = (ticket, userId) =>
  !!ticket && (!ticket.userId || ticket.userId === userId);
